var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.706 7.294c.39.39.39 1.025 0 1.415l-4 4a1.002 1.002 0 0 1-1.415-1.415L12.584 9H6a.999.999 0 1 1 0-2h6.584l-2.293-2.294a1.002 1.002 0 0 1 1.415-1.415l4 4v.003Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 2c0 .553-.447 1-1 1H3c-.553 0-1 .447-1 1v8c0 .553.447 1 1 1h2a.999.999 0 1 1 0 2H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2c.553 0 1 .447 1 1Z",
  opacity: 0.4
})));
export default SvgLogoutIcon;